(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allergy-lp"]) return;
  try {
    
tailwind.config = {
  mode: 'jit',
  prefix: 'pf-',
  theme: {
    fontFamily: {
      'Inter Tight': ['Inter Tight', 'sans-serif'],
      Neuton: ['Neuton', 'serif'],
    },
    extend: {
      animation: {
        marquee: 'marquee 40s linear infinite',
      },
      keyframes: {
        marquee: {
          '0%': { transform: 'translateX(0%)' },
          '100%': { transform: 'translateX(-100%)' },
        },
        marquee2: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(0%)' },
        },
      },
      screens: {
        'iphone': '400px',
      },
    },
  },
};

  } catch(e) { console.error(e); }
})();
})();
